import { styled } from '@grupoboticario/flora'
import { Box, Flex, Text } from '@grupoboticario/flora-react'

export const ModalTutorialWrapper = styled(Box, {
  background: '$backgroundPrimary',
  width: '100%',
})

export const ModalTutorialHeader = styled(Flex, {
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: '0 $4',
  height: 48,
})

export const ModalTutorialHeaderButtonText = styled(Text, {
  color: '$nonInteractiveAuxiliar',
  textDecorationLine: 'underline',
  textUnderlineOffset: 1,
})

export const ModalTutorialDivisorContent = styled(Flex, {
  alignItems: 'center',
  justifyContent: 'center',
  height: 28,
  padding: '0 $4',
  '&:before': {
    background: '$nonInteractiveAltAuxiliar',
    content: ' ',
    display: 'block',
    height: 1,
    width: '100%',
  },
})

export const ModalTutorialFooter = styled(Flex, {
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 $4 $4',
  width: '100%',
})

export const Image = styled('video', {
  width: '150px',
  height: '263.3px',
  pointerEvents: 'none',
  '&.tutorial-image-has-shadows': {
    boxShadow: '0px 8px 24px -8px #00000066',
  },
})

Image.defaultProps = {
  tabIndex: -1,
  autoPlay: true,
  loop: true,
  muted: true,
  playsInline: true,
}
